module.exports = __webpack_public_path__ + "img/66664ed.svg";